<div class="status-tag" [ngClass]="tagClass">
    @if (displayMode === EStatusTagDisplayMode.ICON || displayMode === EStatusTagDisplayMode.BOTH) {
        <i class="pi" [ngClass]="iconClass"></i>
    }
    @if (displayMode === EStatusTagDisplayMode.TEXT || displayMode === EStatusTagDisplayMode.BOTH) {
        <span>{{ displayText }}</span>
    }
    @if (isLocked) {
        <i class="pi pi-lock lock-icon"></i>
    }
</div>
